import { render, staticRenderFns } from "./attachmentLightbox.vue?vue&type=template&id=0a51bb7c&scoped=true"
import script from "./attachmentLightbox.vue?vue&type=script&lang=js"
export * from "./attachmentLightbox.vue?vue&type=script&lang=js"
import style0 from "./attachmentLightbox.vue?vue&type=style&index=0&id=0a51bb7c&prod&scoped=true&lang=css"
import style1 from "./attachmentLightbox.vue?vue&type=style&index=1&id=0a51bb7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51bb7c",
  null
  
)

export default component.exports